import React, { useState, useRef, useEffect } from "react";
import { surveyResult } from "services/_survey";
import { successToast, errorToast } from "components/toast";
import "react-quill/dist/quill.snow.css";

import Spinner from "layouts/spinner";
import {
  SurveyBody,
  PRIOR_DIAGNOSIS_ID,
  PRIOR_DIAGNOSIS_QUESTION,
} from "./SurveyComponent/surveyBody";
import SurveyReferences from "./SurveyComponent/surveyReferences";
import EmailDialog from "./SurveyComponent/emailDialog";
import { getSettingsData } from "services/_settings";

const Surevy = () => {
  const [display, setDisplay] = useState(false);
  const [symptomData, setSymptomData] = useState([]);
  const [diagnosticData, setDiagnosticData] = useState([]);
  const [answers, setAnswers] = useState({});
  const [graphData, setGraphData] = useState({});

  const [showChart1, setShowChart1] = useState(false);
  const [showChart2, setShowChart2] = useState(false);

  const resultClickCountRef = useRef(0);
  const [disableResults, setDisableResults] = useState(false);
  const [disableIncludeTest, setDisableIncludeTest] = useState(false);
  const [phase, setPhase] = useState(1);
  const [open, setOpen] = useState(false);
  const [resultId, setResultId] = useState("");
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  const [settings, setSettings] = useState({});
  const [unanswered, setUnanswered] = useState([]);

  const chart1Ref = useRef(null);
  const chart2Ref = useRef(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await getSettingsData();
        if (res.isSuccess) {
          const settingsObj = {};
          res.data.forEach((item) => {
            settingsObj[item.key] = item.value;
          });
          setSettings(settingsObj);
        }
      } catch (err) {
        console.error("Failed to load settings", err);
      }
    };

    fetchSettings();
  }, []);

  const beginAction = () => {
    if (busyRef.current) return false;
    busyRef.current = true;
    setBusy(true);
    return true;
  };

  const endAction = () => {
    busyRef.current = false;
    setBusy(false);
  };

  const handleSubmit = async () => {
    if (disableResults || busyRef.current) return;

    const requiredIds = symptomData.map((q) => q.id);

    const missing = requiredIds.filter((id) => answers[id] === undefined);
    if (answers[PRIOR_DIAGNOSIS_ID] === undefined) {
      missing.unshift(PRIOR_DIAGNOSIS_ID);
    }

    if (missing.length > 0) {
      setUnanswered(missing);
      errorToast("Please answer all questions before viewing results.");
      return;
    }

    setUnanswered([]);
    if (!beginAction()) return;

    try {
      const symptomDataToSend = symptomData.map((q) => ({
        questionId: q.id,
        question: q.symptoms,
        answer: answers[q.id] ?? false,
      }));
      const diagnosticDataToSend = diagnosticData.map((q) => ({
        questionId: q.id,
        question: q.symptoms,
        answer: answers[q.id] ?? false,
      }));

      const data = await surveyResult({
        symptoms: symptomDataToSend,
        diagnostics: diagnosticDataToSend,
        userInfo: [
          {
            question: PRIOR_DIAGNOSIS_QUESTION,
            answer: answers[PRIOR_DIAGNOSIS_ID],
            type: "prior_diagnosis",
          },
        ],
      });
      if (!data?.isSuccess || !data.data) {
        errorToast(data?.message || "Something went wrong");
        return;
      }

      setGraphData(data.data);
      setResultId(data.data.id);
      successToast("Your survey result is ready");

      if (display) {
        setShowChart1(true);
        setShowChart2(true);
      } else {
        setShowChart1(true);
        setShowChart2(false);
      }

      resultClickCountRef.current += 1;

      if (phase === 1 && resultClickCountRef.current >= 2) {
        setDisableResults(true);
      }

      if (phase === 2 && resultClickCountRef.current >= 2) {
        setDisableResults(true);
        setDisableIncludeTest(true);
      }
    } catch (err) {
      errorToast("Something went wrong");
    } finally {
      endAction();
    }
  };
  const isMobileDevice = () => window.innerWidth <= 768;

  return (
    <>
      <div style={{ backgroundColor: "#fff" }}>
        <div className="body_overly"></div>
        <section
          className="py-[5px]"
          id="surevy_container"
          style={{ alignItems: "center", paddingTop: "5px" }}
        >
          {(loading || busy) && <Spinner isFullScreen={true} />}
          <SurveyBody
            symptomData={symptomData}
            diagnosticData={diagnosticData}
            answers={answers}
            setAnswers={setAnswers}
            handleSubmit={handleSubmit}
            disableResults={disableResults}
            showChart1={showChart1}
            showChart2={showChart2}
            chart1Ref={chart1Ref}
            chart2Ref={chart2Ref}
            graphData={graphData}
            display={display}
            disableIncludeTest={disableIncludeTest}
            settings={settings}
            unanswered={unanswered}
            setUnanswered={setUnanswered}
            setOpen={setOpen}
            resultId={resultId}
            setDisplay={setDisplay}
            setDisableResults={setDisableResults}
            setDisableIncludeTest={setDisableIncludeTest}
            phase={phase}
            setPhase={setPhase}
            setSymptomData={setSymptomData}
            setDiagnosticData={setDiagnosticData}
            setLoading={setLoading}
            setSettings={setSettings}
            resultClickCountRef={resultClickCountRef}
            isMobileDevice={isMobileDevice}
            busy={busy}
            beginAction={beginAction}
            endAction={endAction}
          />

          <div className="container mb-[15px]">
            <SurveyReferences />
          </div>
        </section>
        <EmailDialog
          open={open}
          settings={settings}
          setOpen={setOpen}
          beginAction={beginAction}
          endAction={endAction}
          chart1Ref={chart1Ref}
          chart2Ref={chart2Ref}
          resultId={resultId}
          isMobileDevice={isMobileDevice}
        />
      </div>
    </>
  );
};
export default Surevy;
